<template>
  <div>
    <!-- 活动标题 -->
    <div v-wechat-title="'新仙剑丨永安当打卡挑战'"></div>
    <div :class="'home-wrapper-2 home-' + homeShow">
      <div class="hidden-box ignore-a"></div>
      <div class="home-page" id="home-page">
        <div class="main">
          <div class="container">
            <div class="content-box">
              <div class="service-info" title="区服角色信息">
                <strong>{{ user_userinfo.server_name }}</strong>
                <strong>{{ user_userinfo.role_name }}</strong>
                <span
                  v-show="!this.user_userinfo.account == ''"
                  @click="switchRoles()"
                  v-if="signInState"
                  >切换</span
                >
                <span @click="getLoginContainer()" v-else>登录</span>
                <!-- <span :class="'logout-btn logout-btn-'+logoutBtnClase" v-show="this.user_userinfo.account == ''" @click="logoutShow = true">注销</span> -->
              </div>
              <div class="activity-time" title="活动时间">
                {{ activityCountdownTimeInfo }}
              </div>
              <div class="l-title"></div>
              <div class="signin-wall">
                <div class="wall-bg">
                  <div class="picture" @mouseout="out" @mouseover="over">
                    <img
                      v-for="(item, index) in pic_list"
                      v-show="listIndex === index"
                      :key="index"
                      :src="item"
                      alt=""
                    />
                    <span></span>
                  </div>
                  <div class="plant"></div>
                  <div class="clock-in-wall" title="签到墙">
                    <ul>
                      <li
                        :class="'li-' + item.icon"
                        v-for="(item, i) in signinList"
                        :key="i"
                      >
                        <i :class="'day day-' + item.day"></i>
                        <b
                          :class="
                            'icon icon-' + item.icon + ' is-sign-' + item.state
                          "
                        ></b>
                      </li>
                    </ul>
                  </div>
                  <div
                    class="rule-btn"
                    title="规则按钮"
                    @click="openRule()"
                  ></div>
                </div>
                <div class="btn-all">
                  <div>
                    <!-- is_echarge -->
                    <a
                      v-if="click_end"
                      :class="
                        'clock-in-btn clock-in-' +
                          is_sign +
                          ' is-echarge-' +
                          is_echarge
                      "
                      href="javascript:;"
                      title="打卡签到状态1"
                      @click="goClockIn()"
                    ></a>
                    <a
                      v-else
                      :class="'clock-in-btn clock-in-false'"
                      href="javascript:;"
                      title="打卡签到状态2"
                      @click="goClockInEnd()"
                    ></a>
                  </div>
                  <div>
                    <a
                      v-if="sginNum < 15"
                      :class="
                        'partake-btn partake-' +
                          is_echarge +
                          ' partake-' +
                          user_activity.pay_end_second
                      "
                      href="javascript:;"
                      title="参与按钮"
                      @click="goPartake()"
                    >
                      <p>{{ buyCountdownTimeInfo }}</p>
                    </a>
                    <a
                      v-else
                      :class="'partake-btn drawback-btn drawback-' + is_refund"
                      href="javascript:;"
                      title="返回现金"
                      @click="refundBtn()"
                    >
                    </a>
                  </div>
                </div>
                <div class="cornucopia" title="聚宝盆">
                  <div class="box">
                    <h4>已有{{ total_pay }}名挑战者</h4>
                    <h2 :class="'jinlong-' + scrip"></h2>
                    <h5
                      :class="'grade-' + grade"
                      v-if="user_activity.pay_end_second !== 0"
                    >
                      （满{{ grade }}人分红升级）
                    </h5>
                    <a
                      v-if="
                        user_activity.sgin_day_num >= 15 ||
                          (is_end && is_echarge)
                      "
                      :class="'share-bonus-btn share-bonus-' + is_get_scrip"
                      @click="receiveIntegral()"
                    ></a>
                  </div>
                </div>
                <div class="desktop">
                  <p class="tips">
                    ※活动期间签到未满15天，将无法获得现金返还。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 规则-弹窗 -->
        <div
          id="rule-page"
          @touchmove.prevent
          class="popup_wrap rule-wrap-2"
          v-show="ruleShow"
          @click="ruleShow = false"
        >
          <transition
            enter-active-class="animated zoomInNew"
            leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }"
          >
            <div class="popup-wrap-box" v-show="ruleShow"></div>
          </transition>
        </div>

        <!-- 挑战-弹窗 -->
        <div
          id="challenge-page"
          @touchmove.prevent
          class="popup_wrap challenge-wrap-2"
          v-show="challengeShow"
        >
          <transition
            enter-active-class="animated zoomInNew"
            leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }"
          >
            <div class="popup-wrap-box" v-show="challengeShow">
              <div class="user-info">
                <p>
                  <span>服务器：{{ user_userinfo.server_name }}</span
                  ><span>角色名：{{ user_userinfo.role_name }}</span>
                </p>
              </div>
              <div class="btn-all">
                <a
                  class="cancel-challenge-btn"
                  href="javascript:;"
                  @click="challengeShow = false"
                ></a>
                <a
                  class="confirm-challenge-btn"
                  href="javascript:;"
                  @click="participateChallenges()"
                ></a>
              </div>
            </div>
          </transition>
          <div class="close-bg" @click="challengeShow = false"></div>
        </div>

        <!-- 支付-弹窗 -->
        <div
          id="payment-page"
          class="popup_wrap payment-wrap-2"
          v-show="paymentShow"
        >
          <transition
            enter-active-class="animated zoomInNew"
            leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }"
          >
            <div class="popup-wrap-box" v-show="paymentShow">
              <h2>付款方式</h2>
              <div class="payment-mode">
                <div
                  @click="selectPaymentType(item.payType)"
                  v-for="(item, i) in paymentList"
                  :key="i"
                >
                  <i :class="'icon-' + item.icon"></i
                  ><span>{{ item.name }}</span
                  ><b :class="'select-' + item.select"></b>
                </div>
              </div>
              <div class="btn-box">
                <a href="javascript:;" @click="goToPay">立即支付</a>
              </div>
            </div>
          </transition>
          <div class="close-bg" @click="clonePayment()"></div>
        </div>

        <!-- 支付提示 -->
        <div class="popup_wrap payment-tips-page-2" v-show="paymentTipsShow">
          <transition
            enter-active-class="animated zoomInNew"
            leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }"
          >
            <div class="popup-wrap-box" v-show="paymentTipsShow">
              <h2>提示</h2>
              <p>请确认是否完成支付</p>
              <div>
                <a @click="orderQuery()" href="javascript:;">已完成支付</a>
                <a @click="orderQuery2()" href="javascript:;">未完成支付</a>
              </div>
            </div>
          </transition>
        </div>

        <!-- 打开失败 -->
        <div class="popup_wrap clock-failed-wrap-2" v-show="clockFailedShow">
          <transition
            enter-active-class="animated zoomInNew"
            leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }"
          >
            <div class="popup-wrap-box" v-show="clockFailedShow">
              <div>
                <p>
                  今日获取活跃度: <span>{{ active_value }}</span
                  ><br />请返回游戏继续获取活跃度!
                </p>
                <a
                  @click="clockFailedShow = false"
                  href="javascript:;"
                  class="confirm-btn"
                ></a>
              </div>
            </div>
          </transition>
        </div>

        <!-- 提示弹窗 -->
        <div :class="'tips-wrap tips-wrap-' + tipsShow">
          <div :class="'show-' + tipsShow2">
            <p>{{ tips }}</p>
          </div>
        </div>

        <!-- 支付宝标签 -->
        <div id="aliPayBtn"></div>

        <!-- 退款成功 -->
        <div
          class="refund-success-wrap-2 popup_wrap"
          v-show="refundSuccessShow"
        >
          <transition
            enter-active-class="animated zoomInNew"
            leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }"
          >
            <div class="popup-wrap-box" v-show="refundSuccessShow">
              <a
                class="define-btn"
                @click="refundDef()"
                href="javascript:;"
              ></a>
            </div>
          </transition>
        </div>

        <!-- 注销弹窗 -->
        <div class="logout-wrap popup_wrap" v-show="logoutShow">
          <transition
            enter-active-class="animated zoomInNew"
            leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }"
          >
            <div class="popup-wrap-box" v-show="logoutShow">
              <h2>确定退出当前用户</h2>
              <div>
                <a href="javascript:;" @click="logoutShow = false">取消</a>
                <a href="javascript:;" @click="logoutBtn()">确认</a>
              </div>
            </div>
          </transition>
        </div>

        <!-- 阻止点击弹出-弹窗 -->
        <div
          @touchmove.prevent
          :class="'prevent-wrap prevent-wrap-' + preventShow"
        ></div>
      </div>
      <!-- 登陆模块 -->
      <Login
        v-if="isShowLogin"
        v-on:channelCallback="selectCallback"
        :gameName="gameName"
        :loginTypes="loginTypes"
        downloadUrl="https://static.qcplay.com/tideng/official/"
        channelTips="UID可在游戏中—设置—UID查看"
      ></Login>
      <Os
        v-if="isShowOs"
        v-on:selectCallback="selectCallback"
        v-on:logoutCallback="osCancell"
        :gameName="gameName"
      ></Os>
    </div>
  </div>
</template>
<script>
import { Indicator } from "mint-ui";
import Os from "@/components/os";
import Login from "@/components/login";
import { mapState, mapMutations, mapActions } from "vuex";
import {
  wechatInfoAPI,
  onGetInitDataAPI,
  wxPaymentApi,
  paymentApiV2,
  integralApi,
  clockInApiV2,
  getUuidApi,
  getUseUuidApi,
  getRefundApiV2
} from "../api";
import { analysisParams, getTimeStamp, buriedLogger } from "@/utils/utils";

export default {
  components: {
    Login,
    Os
  },
  data() {
    return {
      gameName: "hjwq",
      logger: null,
      homeShow: false,
      // 其他数据
      loginTypes: ["sms", "password"],
      user_activity: "",
      user_userinfo: "",
      signinList: [
        {},
        { day: 1, icon: 0, state: false },
        { day: 2, icon: 1, state: false },
        { day: 3, icon: 1, state: false },
        { day: 4, icon: 1, state: false },
        { day: 5, icon: 1, state: false },
        { day: 6, icon: 1, state: false },
        { day: 7, icon: 2, state: false },
        { day: 8, icon: 1, state: false },
        { day: 9, icon: 1, state: false },
        { day: 10, icon: 1, state: false },
        { day: 11, icon: 3, state: false },
        { day: 12, icon: 1, state: false },
        { day: 13, icon: 1, state: false },
        { day: 14, icon: 1, state: false },
        { day: 15, icon: 4, state: false }
      ],
      preventShow: false,
      ruleShow: false,
      challengeShow: false,
      refundSuccessShow: false,
      paymentShow: false,
      paymentTipsShow: false,
      clockFailedShow: false,
      logoutShow: false,
      paymentList: [
        {
          icon: "zfb",
          name: "支付宝支付",
          select: "1",
          payType: "alipay",
          payMethod: "wap"
        },
        {
          icon: "wx",
          name: "微信支付",
          select: "0",
          payType: "wechat",
          payMethod: "mp"
        }
      ],
      paymentList2: [
        {
          icon: "zfb",
          name: "支付宝支付",
          select: "1",
          payType: "alipay",
          payMethod: "wap"
        }
      ],
      pic_list: [
        "https://download4.qcplay.com/qcgame-admin/ysMtzxZyDRpESBTtYWd8yZk4V3FaA1w7obRJzA0y.png",
        "https://download4.qcplay.com/qcgame-admin/iTjmyGzASf5cv5GgzBite7O28T63Al6uWqBMr6dL.png",
        "https://download4.qcplay.com/qcgame-admin/La7WPIvtvXCd1hPuXKJWusY6mGW3yfdOfUu5L1ov.png",
        "https://download4.qcplay.com/qcgame-admin/wNJCguqqHZzBA2pIAydLy02YICrg3x2VveqBA7QU.png",
        "https://download4.qcplay.com/qcgame-admin/N0c3u9z7XATGOEv3mYYVf63Q5M4Xcd5ooDA0UKTF.png"
      ],
      // 活跃度
      active_value: "",
      //默认显示第几张图片
      listIndex: 0,
      //定时器
      timer: null,
      // 个人hash信息
      user_params: {
        role_id: "",
        token: "",
        sign: "",
        game_id: "",
        uuid: ""
      },
      logoutBtnClase: true,
      click_end: true,
      // 活动是否结束
      is_end: 0,
      // 签到数量
      sginNum: 0,
      // 当天是否签到
      is_sign: false,
      // 玩家是否充值
      is_echarge: false,
      // 当前支付类型
      paymentData: "",
      // 是否可以领取金龙
      is_get_scrip: false,
      // 现金是否返还
      is_refund: false,
      // 预计可分金龙
      scrip: 388,
      // 支付选择类型
      my_payment_select: 0,
      // 购买倒计时
      buyCountdownTimeInfo: "购买倒计时  00:00:00",
      // 活动剩余时间
      activityCountdownTimeInfo: "",
      // 提示语
      tips: "",
      // 提示显示1
      tipsShow: false,
      // 提示显示2
      tipsShow2: false,
      // 用户是否登录
      signInState: false,
      // 购买的人数
      total_pay: 0,
      // 满多少人分红升级
      grade: 500,
      // 支付订单
      order: "",
      // 计算器名称
      interval: "",
      // 倒计时15s
      wait: 15
    };
  },
  created() {
    //定时器
    this.setTimer();
    // // 清空store上的用户数据
    this.setInitActiveInfo();
    this.setInitUserInfo();
    // 埋点
    const bl = buriedLogger("hjwq", "kfhd_page_2");
    this.logger = bl;
  },
  mounted() {
    this.$nextTick(() => {
      this.monitoringEquipment();
      this.forceLandscapeScreenHandle();
      this.onWindowSizeChanged();
      this.startLoading();
      this.isSetShare();
    });
  },
  computed: {
    ...mapState(["userInfo", "activeInfo", "isShowLogin", "isShowOs"])
  },
  watch: {
    userInfo: {
      handler(newValue, oldValue) {
        // console.log('newValue', newValue);
        // console.log('oldValue', oldValue);
        if (!newValue.role_id) {
          // TAG: 注销的时候
        } else if (newValue.role_id !== oldValue.role_id) {
          // TAG: 初始登陆/切换角色的时候
          const { protocol, host } = window.location;
        }
      }
    }
  },
  methods: {
    monitoringEquipment() {
      if (!navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i))
        location.href = `https://h5.qingcigame.com/hjwq/kfhd_2/pc${getTimeStamp()}`;
      if (
        navigator.userAgent.toLowerCase().match(/MicroMessenger/i) ==
        "micromessenger"
      ) {
        return;
      } else {
        this.paymentList = this.paymentList2;
      }
    },
    // 适配
    forceLandscapeScreenHandle() {
      if (document.activeElement.nodeName === "INPUT") return; // 兼容安卓
      let width = document.documentElement.clientWidth;
      let height = document.documentElement.clientHeight;
      var docEl = document.documentElement,
        fontH = window.innerWidth > window.innerHeight ? height : width;

      const el = document.getElementById("home-page");
      let style = "";
      if (width < height) {
        // 竖版
        style = `transform:rotate(90deg);transform-origin:${width /
          2}px center;width:${height}px;height:${width}px`;
        // this.homeShow = true;
      } else {
        // 横板
        setTimeout(() => {
          document.documentElement.style.fontSize = (75 * fontH) / 750 + "px";
          style = `transform:rotate(0deg);transform-origin:${width /
            2}px center;width:${width}px;height:${height}px`;
          // this.homeShow = true;
          if (el) el.style = style;
        }, 300);
      }
      if (el) el.style = style;
    },
    onWindowSizeChanged() {
      window.addEventListener("resize", this.forceLandscapeScreenHandle);
    },
    isReloadWindow(event) {
      return (
        !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) &&
        ((event && event.persisted) ||
          (window.performance &&
            window.performance.navigation &&
            window.performance.navigation.type === 2))
      );
    },
    startLoading() {
      // 防止第二次进入 微信底部有一个返回条，造成布局问题
      if (this.isReloadWindow()) {
        window.location.reload();
        return;
      }
      // 获取uuid-api
      this.getParams();
    },
    // 获取hash参数
    getParams() {
      const params = analysisParams(window.location.href);
      this.user_params.role_id = params.role_id;
      this.user_params.token = params.token;
      this.user_params.sign = params.sign;
      this.user_params.game_id = params.game_id;
      getUuidApi({
        role_id: this.user_params.role_id,
        token: this.user_params.token,
        sign: this.user_params.sign,
        game_id: this.user_params.game_id
      }).then(response => {
        if (Number(response.code) == 200) {
          this.user_params.uuid = response.data.uuid;
          if (response.data.status == 1) {
            // window.location.href = `https://h5.qingcigame.com/hjwq/kfhd_2/enter${getTimeStamp()}`;
            window.location.replace(`https://h5.qingcigame.com/hjwq/kfhd_2/enter${getTimeStamp()}`)
            return;
          }
          this.localStorageUuid();
        }
        // 请先登录
        if (Number(response.code) == 401) {
          // 开启弹窗
          this.wechatInfo(); // codeId查询api
          return;
        }
      });
    },
    // 存储uuid
    localStorageUuid() {
      console.log("本地", localStorage.getItem("uuid"));
      console.log("api", this.user_params.uuid);
      if (localStorage.getItem("uuid") == this.user_params.uuid) {
        // 本地存在uuid 和 原uuid一致，初始化登录
        this.getLoginContainer();
      }
      this.useUuid();
    },
    // 查询uuid是否使用过
    useUuid() {
      getUseUuidApi({ uuid: this.user_params.uuid }).then(response => {
        // uuid第一次进入
        if (localStorage.getItem("uuid") == null) {
          localStorage.setItem("uuid", this.user_params.uuid);
        }
        this.wechatInfo(); // codeId查询api
      });
    },
    // codeId查询api
    wechatInfo() {
      wechatInfoAPI().then(response => {
        if (Number(response.code) == 200) {
          if (response.data.open_id == null) {
            // 微信下去授权
            if (
              navigator.userAgent.toLowerCase().match(/MicroMessenger/i) ==
              "micromessenger"
            ) {
              window.location.href =
                "//api.qingcigame.com/wechat/get/open/?back=" +
                encodeURIComponent(window.location.href);
              return;
            }
          }
          this.getLoginContainer(); // 初始化登录
          return;
        }
        this.tipsMessage(response.message, 2000);
      });
    },
    // 初始化
    getLoginContainer() {
      var _this = this;
      onGetInitDataAPI().then(response => {
        this.homeShow = true;
        if (Number(response.code) == 200) {
          this.user_activity = response.data.activity;
          this.user_userinfo = response.data.user_info;

          if (
            this.user_userinfo.server_id <= 6 &&
            window.location.pathname.split("/")[2] == "kfhd_2"
          ) {
            // window.location.href = `https://h5.qingcigame.com/hjwq/kfhd/enter${getTimeStamp()}`;
            window.location.replace(`https://h5.qingcigame.com/hjwq/kfhd/enter${getTimeStamp()}`);
          }

          this.onInitDataCallback(response);
          // 登录成功状态
          this.signInState = true;
          // 活动是否结束按钮
          this.click_end = this.user_activity.click_end;

          this.is_end = this.user_activity.is_end;
          // 右上角的活动时间-是否结束
          if (this.user_activity.is_end && this.user_activity.end_time == 0) {
            this.activityCountdownTimeInfo = "活动已结束";
          } else {
            this.activityCountdownTimeInfo =
              "活动剩余时间" + this.user_activity.end_time;
          }
          // 当天是否签到
          this.is_sign = this.user_activity.is_sign;
          // 签到天数
          this.user_activity.sgin_day_num > 15
            ? (this.sginNum = 15)
            : (this.sginNum = this.user_activity.sgin_day_num);
          for (var i = 0; i <= 15; i++) this.signinList[i].state = false; // 清除签到记录
          for (var i = 0; i <= this.sginNum; i++)
            this.signinList[i].state = true; // 渲染真实签到记录
          // 玩家是否充值
          this.is_echarge = this.user_activity.is_echarge;
          // 购买的人数（金龙位置显示-挑战者人数）
          this.total_pay = this.user_activity.total_pay;
          // 满多少人分红升级
          this.grade = this.user_activity.grade;
          // 预计可分金龙
          this.scrip = this.user_activity.scrip;
          // 是否可以领取金龙
          this.is_get_scrip = this.user_activity.is_get_scrip;
          // 现金是否返还
          this.is_refund = this.user_activity.is_refund;
          // 倒计时清除
          window.clearTimeout(this.interval);
          // 购买倒计时时间-展示
          this.user_activity.pay_end_second !== 0
            ? this.buyTimeShow()
            : (this.buyCountdownTimeInfo =
                this.user_activity.pay_end_time + " 截止购买");
          return;
        }
        // 请登录
        if (Number(response.code) == 401) {
          this.signInState = false;
          this.onInitDataCallback(response);
          return;
        }
        this.tipsMessage(response.message, 2000);
      });
    },
    // 清空数据
    cleanData() {
      this.click_end = true;
      // 活动是否结束
      this.is_end = false;
      // 用户是否登录
      this.signInState = false;
      // 活动剩余时间
      this.activityCountdownTimeInfo = "";
      // 当天是否签到
      this.is_sign = false;
      // 清除签到记录
      for (var i = 0; i <= 15; i++) this.signinList[i].state = false;
      // 玩家是否充值
      this.is_echarge = false;
      // 购买的人数（金龙位置显示-挑战者人数）
      this.total_pay = 0;
      // 满多少人分红升级
      this.grade = 500;
      // 预计可分金龙
      this.scrip = 388;
      // 是否可以退钱
      this.is_get_scrip = false;
      // 现金是否返还
      this.is_refund = false;
      // 购买倒计时
      this.buyCountdownTimeInfo = "购买倒计时  00:00:00";
      // 支付选择类型
      this.my_payment_select = 0;
      // 用户名称
      this.user_userinfo.role_name = "";
      // 用户区服
      this.user_userinfo.server_name = "";
      // 购买时间
      this.user_activity.pay_end_time = "";
      // 活动结束状态
      this.user_activity.pay_end_second = undefined;
      // 签到的数量
      this.sginNum = 0;
      // 签到天数
      this.user_activity.sgin_day_num = 0;
      // 倒计时清除
      window.clearTimeout(this.interval);
    },
    // 前往参与
    goPartake() {
      // 未参与活动
      if (this.user_activity.pay_end_second == 0 && !this.is_echarge) {
        this.tipsMessage("非常抱歉，您未参与活动！", 2000);
        return;
      }
      // 用户没登录
      if (!this.signInState) {
        this.getLoginContainer();
        return;
      }
      // 未充值-前往充值
      if (!this.is_echarge) {
        this.challengeShow = true;
      } else {
        this.tipsMessage("您已参与活动，无需重复购买", 2000);
      }
    },
    tipsMessage(message, times) {
      this.tipsShow = true;
      this.tips = message;
      setTimeout(() => {
        this.tipsShow2 = true;
      }, 100);
      setTimeout(() => {
        this.tipsShow2 = false;
      }, times - 200);
      setTimeout(() => {
        this.tipsShow = false;
        this.tips = "";
      }, times);
    },
    // 参与挑战按钮
    participateChallenges() {
      this.challengeShow = false;
      this.paymentShow = true;
      this.paymentList[this.my_payment_select];
      this.paymentData = this.paymentList[this.my_payment_select];
      // 监测是否微信 (是为mp，否则map)
      if (this.paymentList.length > 1) {
        if (
          navigator.userAgent.toLowerCase().match(/MicroMessenger/i) ==
          "micromessenger"
        ) {
          this.paymentList[1].payMethod = "mp";
        } else {
          this.paymentList[1].payMethod = "wap";
        }
      }
    },
    // 选择支付方式
    selectPaymentType(payType) {
      navigator.userAgent.toLowerCase().match(/MicroMessenger/i) ==
        "micromessenger";
      payType == "wechat"
        ? (this.my_payment_select = 1)
        : (this.my_payment_select = 0);
      for (var i = 0; i <= this.paymentList.length - 1; i++)
        this.paymentList[i].select = 0;
      this.paymentList[this.my_payment_select].select = 1;
      this.paymentData = this.paymentList[this.my_payment_select];
    },
    // 立即支付
    goToPay() {
      this.preventShow = true;
      paymentApiV2({
        pay_type: this.paymentData.payType,
        pay_method: this.paymentData.payMethod
      }).then(response => {
        if (Number(response.code) == 200) {
          // 支付订单存储
          this.order = response.data.order;
          this.paymentTipsShow = true;
          // 移动端
          if (navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) {
            // 微信发送支付
            if (this.paymentData.payType == "wechat") {
              // 外部浏览器调用
              if (this.paymentData.payMethod == "mp") {
                wx.chooseWXPay({
                  timestamp: response.data.data.timeStamp, // 支付签名时间戳，注意微信 jssdk 中的所有使用 timestamp 字段均为小写。但最新版的支付后台生成签名使用的 timeStamp 字段名需大写其中的 S 字符
                  nonceStr: response.data.data.nonceStr, // 支付签名随机串，不长于 32 位
                  package: response.data.data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                  signType: response.data.data.signType, // 微信支付V3的传入 RSA ,微信支付V2的传入格式与V2统一下单的签名格式保持一致
                  paySign: response.data.data.paySign, // 支付签名
                  success: function(res) {
                    // 支付成功后的回调函数
                    setTimeout(() => {
                      this.preventShow = false;
                    }, 1000);
                  },
                  fail: function(res) {
                    setTimeout(() => {
                      this.preventShow = false;
                    }, 1000);
                  }
                });
                setTimeout(() => {
                  this.preventShow = false;
                }, 2000);
              } else {
                if (response.data.data !== "") {
                  window.location.href = response.data.data;
                  setTimeout(() => {
                    this.preventShow = false;
                  }, 1000);
                }
              }
            }
            // // 支付宝
            if (response.data.data !== "") {
              document.getElementById("aliPayBtn").innerHTML =
                response.data.data;
              document.forms["alipaysubmit"].submit();
              setTimeout(() => {
                this.preventShow = false;
              }, 1000);
            }
          }
          return;
        }
        this.tipsMessage(response.message, 2000);
        setTimeout(() => {
          this.preventShow = false;
        }, 500);
      });
    },
    // 订单轮询
    orderLoop(i) {
      if (this.wait > 0) {
        this.wxPayment(i);
        this.wait--;
        Indicator.open();
        setTimeout(() => {
          this.orderLoop(i);
        }, 1500);
      }
    },
    // 订单查询
    wxPayment(i) {
      wxPaymentApi({ trade_no: this.order }).then(response => {
        if (Number(response.code) == 200) {
          // 支付成功
          this.wait = 0;
          if (i == 1) this.tipsMessage(response.message, 2000);
          this.paymentShow = false; // 关闭支付弹窗
          this.getLoginContainer(); // 初始化数据
          Indicator.close();
          return;
        }
        if (Number(response.code) != 200) {
          if (this.wait == 0) {
            if (i == 1) this.tipsMessage(response.message, 2000);
            Indicator.close();
            return;
          }
        }
      });
    },
    // 领取金龙（积分）
    receiveIntegral() {
      if (this.is_get_scrip) {
        integralApi().then(response => {
          this.tipsMessage(response.message, 2000);
          this.getLoginContainer();
        });
      }
    },
    // 签到-按钮
    goClockIn() {
      if (!this.is_sign) {
        clockInApiV2().then(response => {
          if (Number(response.code) == 200) {
            this.getLoginContainer();
            this.tipsMessage(response.message, 3000);
            return;
          }
          if (Number(response.code) == 408) {
            this.clockFailedShow = true;
            this.active_value = response.data.active_value;
            return;
          }
          this.tipsMessage(response.message, 3000);
        });
      } else {
        this.preventShow = true;
        // 前往登录
        this.getLoginContainer();
        setTimeout(() => {
          this.preventShow = false;
        }, 2000);
      }
    },
    // 活动已结束-点击提示
    goClockInEnd() {
      this.tipsMessage("非常抱歉，活动已结束！", 2000);
    },
    // 购买时间显示
    buyTimeShow() {
      let _this = this;
      let payEndTime = this.user_activity.pay_end_time;
      let hours = payEndTime.split(":")[0]; //剩余小时数
      let minutes = payEndTime.split(":")[1]; //剩余分钟数
      let seconds = payEndTime.split(":")[2]; //剩余秒数
      function time() {
        if (seconds == 0) {
          seconds = 60;
          minutes >= 1 ? minutes-- : hours--;
          if (hours !== 0 && minutes !== 0 && seconds !== 0) {
            time();
          }
        } else {
          seconds--;
          _this.buyCountdownTimeInfo =
            "购买倒计时 " +
            checkTime(hours) +
            ":" +
            checkTime(minutes) +
            ":" +
            checkTime(seconds);
          _this.interval = setTimeout(function() {
            time();
          }, 1000);
        }
      }
      time();

      function checkTime(i) {
        if (i < 10) {
          i = "0" + i;
        }
        return i;
      }
    },
    // 点击规则按钮
    openRule() {
      this.ruleShow = true;
      this.logger.sum("rule_btn");
    },
    // 退款按钮
    refundBtn() {
      if (this.is_refund) {
        getRefundApiV2().then(response => {
          if (Number(response.code) == 200) {
            this.refundSuccessShow = true;
            return;
          }
          this.tipsMessage(response.message, 2000);
        });
      }
    },
    // 退款返回确定
    refundDef() {
      this.refundSuccessShow = false;
      this.getLoginContainer();
    },
    // 关闭支付弹窗
    clonePayment() {
      this.paymentShow = false;
      this.getLoginContainer(); // 初始化登录
    },
    orderQuery() {
      this.paymentTipsShow = false;
      // 订单轮询
      this.wait = 15;
      this.orderLoop(1);
    },
    orderQuery2() {
      this.paymentTipsShow = false;
      // 订单轮询
      this.wait = 2;
      this.orderLoop(2);
    },
    // 切换角色
    switchRoles() {
      this.openLoginOS();
    },
    // 注销按钮
    // logoutBtn() {
    //   LogoutAPI()
    //     .then((response) => {
    //       if (Number(response.code) == 200) {
    //         this.logoutShow = false;
    //         this.logoutBtnClase = false;
    //         this.cleanData();
    //         this.getLoginContainer();
    //       }
    //       this.tipsMessage(response.message, 2000);
    //   });
    // },
    selectCallback() {
      this.getLoginContainer();
    },
    osCancell() {
      // 清空数据
      this.cleanData();
      this.getLoginContainer();
    },
    //移除
    out() {
      this.setTimer();
    },
    //移入
    over() {
      clearInterval(this.timer);
    },
    //1秒切图
    setTimer() {
      this.timer = setInterval(() => {
        this.listIndex++;
        if (this.listIndex == this.pic_list.length) {
          this.listIndex = 0;
        }
      }, 2000);
    },
    // TODO: 登陆弹窗demo
    openLoginOS() {
      if (this.userInfo.role_id) {
        this.changeOsPopup(true);
      } else {
        this.changeLoginPopup(true);
      }
    },
    isSetShare() {
      this.setShare({
        link: `https://h5.qingcigame.com/hjwq/kfhd_2/enter${getTimeStamp()}`,
        title: "新仙剑丨永安当打卡挑战",
        imgUrl:
          "https://download4.qcplay.com/qcgame-admin/9VvEpdxHDip5WGqaDMHZf6dkbiStRBLhJenoYRE6.png",
        desc: "新服打卡挑战中，福利还是免费的香！"
      });
    },
    ...mapMutations([
      "setUserInfo",
      "setInitUserInfo",
      "confirmLogout",
      "setInitActiveInfo",
      "changeLoginPopup",
      "changeOsPopup"
    ]),
    ...mapActions(["onInitDataCallback", "setShare"])
  }
};
</script>

<style lang="less">
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/hjwq/kfhd2/index/index.vue